import axios from 'axios';

export const requestDemoService = async ({email}) => {
    try {
        console.log('Requesting demo with email:', email);
        const response = await axios.post('/api/request-demo', { email });
        return response.data;
    } catch (error) {
        console.error('Error requesting demo:', error);
        throw error;
    }
};
